import type { Brand } from 'src/App/generated/graphql-types';
import { isExistingBrand } from './is-existing-brand';
import type { NewBrand } from 'src/types';

export const isAsiaCover = (brand: Brand | NewBrand): boolean =>
  isExistingBrand(brand) &&
  Boolean(brand.assets.cover?.strategies['seek-asia-banner']) &&
  !brand.assets.cover?.strategies['jdp-cover'];
